import { render, staticRenderFns } from "./GoodsManagementView.vue?vue&type=template&id=28f9c5ec&scoped=true"
import script from "./GoodsManagementView.vue?vue&type=script&lang=js"
export * from "./GoodsManagementView.vue?vue&type=script&lang=js"
import style0 from "./GoodsManagementView.vue?vue&type=style&index=0&id=28f9c5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9c5ec",
  null
  
)

export default component.exports